// extracted by mini-css-extract-plugin
export default {"accordion_root":"Eha","accordion_summary":"Fha","accordion_details_root":"Gha","expand_icon":"Hha","rotate_arrow":"Iha","info_item":"Jha","ingredient":"Kha","title":"Lha","product":"Mha","img":"Nha"};
    if(module.hot) {
      // 1730991513208
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  